import React from 'react';
import styled from 'styled-components';

const RefundPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="bg-gradient-to-r from-blue-600 to-purple-700 px-6 py-8">
            <h1 className="text-4xl font-bold text-white text-center">
              Refund Policy
            </h1>
          </div>
          
          <div className="px-6 py-8">
            <PolicyContainer>
              <IntroText>
                At SRK Softwares, we strive to ensure your satisfaction with our products and services. 
                If for any reason you are not entirely satisfied with your purchase, you may be eligible 
                for a refund subject to the following conditions:
              </IntroText>

              <SectionTitle>Refund Eligibility:</SectionTitle>
              <BulletList>
                <li>Refund requests must be submitted in writing to our support department within thirty (30) days from the completion of your order.</li>
                <li>Products or services such as domain registrations, Reseller Hosting, Dedicated Hosting, Bulk SMS, Bulk Email, Website Designing, SSL Certificates, and similar services are non-refundable and will be deducted from the total refund amount.</li>
                <li>A detailed reason for cancellation is required. We evaluate the validity of the reason and the steps taken by both parties to address the concerns.</li>
                <li>Any unpaid invoice after the 15th day will incur a 14% fine based on the total amount.</li>
              </BulletList>

              <SectionTitle>Payment Methods:</SectionTitle>
              <BulletList>
                <li>We accept various payment methods, including Debit cards, Credit cards, UPI, NEFT, Checks, and cash.</li>
              </BulletList>

              <SectionTitle>Price Variation:</SectionTitle>
              <BulletList>
                <li>Prices for products and services may vary over time.</li>
              </BulletList>

              <SectionTitle>Refund Process:</SectionTitle>
              <BulletList>
                <li>Refunds, when applicable, will be processed within 7 working days.</li>
                <li>Refunds will be issued via Account Credits, direct deposit to your bank account, or to the original payment method used (e.g., credit card, bank account for Payment Gateway Name payments).</li>
              </BulletList>

              <SectionTitle>Cancellation Procedure:</SectionTitle>
              <BulletList>
                <li>To cancel services, contact our billing department through a support request or email to contact@srksoftwares.com</li>
              </BulletList>

              <SectionTitle>Additional Terms:</SectionTitle>
              <BulletList>
                <li>There are no refunds on certain services as mentioned previously.</li>
                <li>Refund requests for shared and reseller accounts after the initial 30 days will be prorated for any unused time.</li>
                <li>Only first-time accounts are eligible for a refund.</li>
                <li>Domain Name Registration / Domain Transfer and related services are non-refundable once purchased.</li>
                <li>SRK Softwares reserves the right to cancel accounts without notice and refund.</li>
                <li>Changes to our policies may occur without prior notice.</li>
              </BulletList>

              <SectionTitle>Social Media Service Disclaimer:</SectionTitle>
              <BulletList>
                <li>No refunds are available for Social Media Services.</li>
              </BulletList>

              <DisclaimerBox>
                <p className="font-semibold mb-2">Important Notice:</p>
                Please ensure you have thoroughly reviewed our Terms, Privacy Policy, and Refund Policy before placing an order. For any queries or assistance regarding refunds or cancellations, contact us at <ContactInfo>( 62013 19591 and email: contact@srksoftwares.com)</ContactInfo>.
              </DisclaimerBox>
            </PolicyContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

const PolicyContainer = styled.div`
  line-height: 1.6;
  color: #374151;
`;

const IntroText = styled.p`
  font-size: 1.125rem;
  margin-bottom: 2rem;
  color: #4b5563;
  text-align: justify;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  color: #1f2937;
  margin-top: 2rem;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e5e7eb;
`;

const BulletList = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 1.5rem;

  li {
    position: relative;
    padding-left: 2rem;
    margin-bottom: 0.75rem;
    
    &:before {
      content: '●';
      position: absolute;
      left: 0;
      color: #3b82f6;
      font-weight: bold;
    }
  }
`;

const DisclaimerBox = styled.div`
  background-color: #fef3cd;
  border: 1px solid #f59e0b;
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin-top: 2rem;
  color: #92400e;
`;

const ContactInfo = styled.span`
  font-weight: bold;
  color: #dc2626;
`;

export default RefundPolicy;